// ================ Action types ================ //

import { getClientData } from '../util/clientData';

export const DISABLE_SCROLLING = 'app/UI/DISABLE_SCROLLING';

export const SET_MOBILE_MENU = 'app/UI/SET_MOBILE_MENU';

export const SET_SETTINGS_MENU = 'app/UI/SET_SETTINGS_MENU';

export const SET_ANNUAL_PASS_BANNER = 'app/UI/SET_ANNUAL_PASS_BANNER';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.UI} */
const initialState = {
  disableScrollRequests: [],
  mobileMenuState: false,
  settingsMenuState: false,
  yellowBannerState: getClientData('vansite.yellowBannerClosed') !== undefined ? !getClientData('vansite.yellowBannerClosed') : true,
};

/**
 *
 * @param state
 * @param action
 */
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DISABLE_SCROLLING: {
      const { componentId, disableScrolling } = payload;
      const disableScrollRequests = state.disableScrollRequests;
      const componentIdExists = disableScrollRequests.find((c) => c.componentId === componentId);

      if (componentIdExists) {
        const disableScrollRequestArray = disableScrollRequests.map((c) => {
          return c.componentId === componentId ? { ...c, disableScrolling } : c;
        });
        return { ...state, disableScrollRequests: [...disableScrollRequestArray] };
      }

      const disableScrollRequestArray = [
        ...disableScrollRequests,
        { componentId, disableScrolling },
      ];
      return {
        ...state,
        disableScrollRequests: disableScrollRequestArray,
      };
    }

    case SET_MOBILE_MENU: {
      return {
        ...state,
        mobileMenuState: payload,
      };
    }

    case SET_SETTINGS_MENU: {
      return {
        ...state,
        settingsMenuState: payload,
      };
    }

    case SET_ANNUAL_PASS_BANNER: {
      return {
        ...state,
        yellowBannerState: payload,
      };
    }

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const manageDisableScrolling = (componentId, disableScrolling) => ({
  type: DISABLE_SCROLLING,
  payload: { componentId, disableScrolling },
});

export const setMobileMenu = (state) => ({
  type: SET_MOBILE_MENU,
  payload: state,
});

export const setSettingsMenu = (state) => ({
  type: SET_SETTINGS_MENU,
  payload: state,
});

export const setYellowBanner = (state) => ({
  type: SET_ANNUAL_PASS_BANNER,
  payload: state,
});

// ================ Selectors ================ //

export const isScrollingDisabled = (disableScrollRequests) => {
  return disableScrollRequests.some((r) => r.disableScrolling);
};

export const setMobileMenuState = (state) => (dispatch) => {
  dispatch(setMobileMenu(state));
};

export const setSettingsMenuState = (state) => (dispatch) => {
  dispatch(setSettingsMenu(state));
};
